import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { PatientService } from "@kells/clinic-one/apis";
import { KellsPatient } from "@kells/interfaces/patient";
import { take } from "rxjs/operators";
import { BehaviorSubject } from "rxjs";

@Component({
  selector: "koa-upgrade-plan-address",
  templateUrl: "./upgrade-plan-address.component.html",
  styleUrls: ["./upgrade-plan-address.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UpgradePlanAddressComponent implements OnInit {
  @Input() selectedPatient: KellsPatient;

  @Output() back = new EventEmitter<void>();

  @Output() upgradePlan = new EventEmitter<void>();

  public readonly isSubmitting$ = new BehaviorSubject<boolean>(false);

  form: FormGroup = this.fb.group({
    street: ["", Validators.required],
    city: ["", Validators.required],
    state: ["", Validators.required],
    zipcode: ["", Validators.required],
  });

  constructor(
    private fb: FormBuilder,
    private patientService: PatientService
  ) {}

  ngOnInit(): void {
    this.form.patchValue({
      street: this.selectedPatient.street1,
      city: this.selectedPatient.city,
      state: this.selectedPatient.state,
      zipcode: this.selectedPatient.zipcode,
    });
  }

  private _updateValueAndValidity() {
    for (const controlName in this.form.controls) {
      this.form.controls[controlName].updateValueAndValidity();
    }
  }

  public onBackToPlansClick(event: Event) {
    event.preventDefault();
    this.back.emit();
  }

  onSubmit() {
    this._updateValueAndValidity();
    this.form.markAllAsTouched();

    if (!this.form.valid) {
      return;
    }

    this.isSubmitting$.next(true);

    const data = {
      id: this.selectedPatient.id,
      street1: this.form.value.street,
      city: this.form.value.city,
      state: this.form.value.state,
      zipcode: this.form.value.zipcode,
    };

    this.patientService
      .updatePatient(data)
      .pipe(take(1))
      .subscribe(
        () => {
          this.isSubmitting$.next(false);
          this.upgradePlan.emit();
        },
        () => {
          this.isSubmitting$.next(false);
        }
      );
  }
}
